import React, { FC } from 'react';
import injectSheet from 'react-jss';
import Tooltip from 'HOC/Tooltip';
import LongTextEllipsis from 'Components/LongTextEllipsis';
import { FormattedDate } from 'Utils/formattedDate';
import mapVisitorType from 'Utils/mapVisitorType';
import InterestBars from './InterestBars';
import styleSheet from './styles';

interface Props {
  data: any;
  loading?: boolean;
  error?: boolean;
  classes?: any;
}

const ProfileHeader: FC<Props> = (props: Props) => {
  const { data, loading, error, classes } = props;

  if (loading || error) {
    return null;
  }

  // For readability, destructure here and not in the incoming params
  const {
    visitorType,
    firstName,
    lastName,
    highSchoolLevelToday,
    relativeInterestLevel,
    lastDateActiveWithYouvisit,
    lastDateActiveWithInstitution,
  } = data.audience.audience.profile;
  const name = `${firstName} ${lastName}`;

  return (
    <div className={`${classes.container} ${classes.row}`}>
      <div className={`${classes.col} ${classes.col1}`}>
        <div className={classes.row}>
          <div className={classes.name}>
            <Tooltip
              position="bottom"
              text={name}
              offsetTop={45}
              offsetLeft={30}
            >
              <LongTextEllipsis className={classes.name} value={name} />
            </Tooltip>
          </div>
        </div>
        {visitorType && (
          <div className={classes.row}>
            <div className={`${classes.desc} ${classes.alignVerticalTop}`}>
              {/* Currently this will render "parent of parent", once audience list is finalized we need to map the visitor types for correct verbage */}
              {`${
                visitorType.includes('parent') ? 'Parent of ' : ''
              }${mapVisitorType(visitorType, highSchoolLevelToday)}`
                .replace('HS', 'High School')
                .replace('(Parent)', '')
                .replace('Grad', 'Graduate')}
            </div>
          </div>
        )}
      </div>
      <div className={`${classes.col} ${classes.col2}`}>
        <div className={`${classes.row} ${classes.rowMarginTopRow}`}>
          <div
            className={`${classes.sectionName} ${classes.relativeEngagement}`}
          >
            <Tooltip
              position="top"
              text="Visitor’s level of engagement in your institution relative to other institutions and to other visitors (High, Medium, Low)"
              offsetTop={-45}
              offsetLeft={-280}
            >
              Relative Engagement
            </Tooltip>
          </div>
        </div>
        <div className={`${classes.row}`}>
          <div className={classes.alignVerticalTop}>
            {relativeInterestLevel ? (
              <InterestBars level={relativeInterestLevel} />
            ) : (
              <span
                className={`${classes.sectionName} ${classes.notAvailable}`}
              >
                -
              </span>
            )}
          </div>
        </div>
      </div>
      <div className={`${classes.col} ${classes.col3}`}>
        <div
          className={`${classes.row} ${classes.datesRowMarginTopRow} ${classes.end}`}
        >
          <div
            className={`${classes.sectionName} ${classes.dateLastActiveInEabNetwork}`}
          >
            <span>Date Last Active in EAB&apos;s Network</span>
          </div>
        </div>
        <div className={`${classes.row} ${classes.end}`}>
          <div
            className={`${classes.lastActivityDates} ${classes.alignVerticalTop}`}
          >
            {lastDateActiveWithYouvisit ? (
              FormattedDate(lastDateActiveWithYouvisit)
            ) : (
              <span>-</span>
            )}
          </div>
        </div>
      </div>
      <div className={`${classes.col} ${classes.col4}`}>
        <div
          className={`${classes.row} ${classes.datesRowMarginTopRow} ${classes.end}`}
        >
          <div
            className={`${classes.sectionName} ${classes.dateLastActiveWithMyInstitution}`}
          >
            <span>Date Last Active With My institution</span>
          </div>
        </div>
        <div className={`${classes.row} ${classes.end}`}>
          <div
            className={`${classes.lastActivityDates}  ${classes.alignVerticalTop}`}
          >
            {lastDateActiveWithInstitution ? (
              FormattedDate(lastDateActiveWithInstitution)
            ) : (
              <span>-</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

ProfileHeader.defaultProps = {
  loading: false,
  error: false,
  classes: {},
};

export default injectSheet(styleSheet)(ProfileHeader);
